import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const SchoolLibrary = () => {
    useEffect(() => {
        document.title = 'School Library -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>School Library</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Library </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                      <p>The School Library is open to all bonafide students of the school. All classes are provided with at least one library period per week. There are more than 20,000 books on various topics , subjects, the latest fiction, classics and encyclopedias. The issue and return of the books is computerized and done with the help of a bar-code reader. The library is open throughout the year.</p>
                </div>
                <div className="col-lg-4">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Library.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Library.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-lg-4">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Library1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Library1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-lg-4">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Library2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Library2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div>
              <div className="col-lg-4">
              <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Library3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Library3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
            </LazyLoad>  
             </div>
             <div className="col-lg-4">
             <LazyLoad>
             <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/Library4.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Library4.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
           </LazyLoad>  
            </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default SchoolLibrary